import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Subtitle = (props: Props) => {
  const className = `font-jost-medium text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-[32px] ${mapStylesFromProps(
    props
  )}`
  return (
    <span className={className} style={props.style}>
      {props.children}
    </span>
  )
}

export default Subtitle
